__turbopack_context__.v({
  "dash": "CircleLoader-module__8nTgva__dash",
  "path": "CircleLoader-module__8nTgva__path",
  "rotate": "CircleLoader-module__8nTgva__rotate",
  "spinner": "CircleLoader-module__8nTgva__spinner",
});
